import { getApiUrl } from '../config';
import { storage } from '../lib/storage';
import { notify } from './toast';

export const refreshProfile = async (walletAddress: string): Promise<any> => {
  const loadingToastId = notify.loading('Syncing profile...');
  
  try {
    // Get profile from storage first
    let profile = await storage.getProfile(walletAddress);
    
    if (!profile?.jwt || !profile?.nonce) {
      console.log('No JWT or nonce found in profile');
      notify.dismiss(loadingToastId);
      return null;
    }

    const url = `${getApiUrl()}/profile`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${profile.jwt}`,
      },
      body: JSON.stringify({
        walletAddress,
        nonce: profile.nonce
      })
    });

    if (!response.ok) {
      throw new Error('Failed to refresh profile');
    }

    const result = await response.json();
    
    if (result?.profile) {
      // Update profile with new data while preserving JWT and nonce
      const updatedProfile = {
        ...result.profile,
        jwt: profile.jwt,
        nonce: profile.nonce,
        credit: result.profile.credit || 0
      };

      // Store updated profile
      await storage.setProfile(walletAddress, updatedProfile);
      
      notify.dismiss(loadingToastId);
      notify.success('Profile synced successfully');
      return updatedProfile;
    }

    throw new Error('Invalid profile data received');
  } catch (error: any) {
    console.error('Profile refresh error:', error);
    notify.dismiss(loadingToastId);
    notify.error(error.message || 'Failed to refresh profile');
    return null;
  }
};